import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { clearAdminSecret } from "../lib/auth.ts";

const NAV = [
  { to: "/",        label: "Dashboard",   icon: "⊞" },
  { to: "/review",  label: "Review Queue", icon: "✎" },
  { to: "/browse",  label: "Feed Browse",  icon: "⊙" },
  { to: "/curate",  label: "Curation",     icon: "◎" },
  { to: "/feeds",   label: "Feeds",        icon: "⊑" },
  { to: "/settings",label: "Settings",     icon: "⚙" },
  { to: "/audit",   label: "Audit Log",    icon: "≡" },
  { to: "/diagnostics", label: "Diagnostics", icon: "◉" },
];

export default function Layout() {
  const navigate = useNavigate();

  function handleLogout() {
    clearAdminSecret();
    navigate("/login", { replace: true });
  }

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      {/* Sidebar */}
      <aside className="w-56 flex-shrink-0 bg-gray-900 flex flex-col">
        <div className="px-5 py-4 border-b border-gray-700">
          <span className="text-white font-semibold text-sm tracking-tight">
            365infomedia
          </span>
          <p className="text-gray-400 text-xs mt-0.5">News Editing System</p>
        </div>
        <nav className="flex-1 py-3 overflow-y-auto">
          {NAV.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 text-sm transition-colors ${
                  isActive
                    ? "bg-brand-600 text-white"
                    : "text-gray-400 hover:text-white hover:bg-gray-800"
                }`
              }
            >
              <span className="w-4 text-center text-base leading-none">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-4 py-3 border-t border-gray-700 space-y-2">
          <p className="text-gray-500 text-xs">v0.1.0 — Phase 1</p>
          <button
            onClick={handleLogout}
            className="text-xs text-gray-400 hover:text-white transition-colors"
          >
            Sign Out
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
